import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from '../../../../../../types/types';
import { root } from '../../../../../../store/constants';
import { SegmentInAppNotificationEvent, segmentTrackAction } from '../../../../../../middlewares/segment';
import { SegmentNotificationOption } from '../../../../../../middlewares/segment/trackEntities/inAppNotificationEvents';

export function onClick (
    isLast: boolean,
    isRead: boolean,
    type: string,
): ThunkAction {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const option = isRead ? null : {
            name: SegmentNotificationOption.TYPE,
            value: type,
        };
        const event = isRead ? SegmentInAppNotificationEvent.FAKE_NOTIFICATION_READ
            : SegmentInAppNotificationEvent.FAKE_NOTIFICATION_CLICKED;
        dispatch(segmentTrackAction(event, option));
        if (isLast) {
            root.App.controller.notificationsView.removeFakeNotification();
        }
    };
    return action
};
